export default __webpack_public_path__ + "static/media/fad-repeat.4b315477.svg";